"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocalizationFunction = exports.getLocalization = void 0;
var getLocalization = function (x) { return x; };
exports.getLocalization = getLocalization;
var setLocalizationFunction = function (func) {
    exports.getLocalization = func;
};
exports.setLocalizationFunction = setLocalizationFunction;
//# sourceMappingURL=translation.js.map